import Flickity from 'flickity';

const initSubmitSlider = (slider) => {
    const flkty = new Flickity(slider, {
        cellAlign: 'left',
        wrapAround: true,
        freeScroll: true,
        cellSelector: '.js-cell',
        freeScrollFriction: 0.04,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
    });

    // Setup/config bits
    const BASE = 0.8;
    const STEP = 2.5;
    const MAX = 3;
    const DELAY = 180;
    const DECAY = 0.5;

    let dir = 1;
    let boost = 0;
    let rafId = null;
    let decayTmr = null;

    // Animation loop
    function tick() {
        flkty.x -= (BASE + boost) * dir;
        flkty.settle(flkty.x);
        rafId = requestAnimationFrame(tick);
    }

    const start = () => {
        if (!rafId) rafId = requestAnimationFrame(tick);
    };

    start();

    // Listen for scroll events
    window.addEventListener('wheel', (e) => {
        const newDir = e.deltaY > 0 ? 1 : -1;

        if (newDir === dir) {
            boost = Math.min(boost + STEP, MAX);
        } else {
            dir = newDir;
            boost = STEP;
        }

        clearTimeout(decayTmr);
        decayTmr = setTimeout(decay, DELAY);
    }, { passive: false },
    );

    function decay() {
        if (boost <= 0.05) {
            boost = 0;
            return;
        }
        boost *= DECAY;
        decayTmr = setTimeout(decay, 16);
    }
};

export default initSubmitSlider;
